<template>
  <div :class="$style.highlights" role="list">
    <div
      v-for="(item, index) in items"
      :key="`highlight-${index}`"
      :class="[$style.highlight, $style[`highlight${index + 1}`]]"
      role="listitem"
    >
      <div :class="$style.highlightValue">{{ item.value }}</div>
      <div :class="$style.highlightLabel">{{ item.label }}</div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'HomeTestimonialsHighlights',

  props: {
    items: {
      type: Array,
      required: true,
    },
  },
}
</script>

<style lang="scss" module>
.highlights {
  display: grid;
  grid-template-columns: 1fr;
  gap: 16px;
  margin: 0 auto 48px;
  max-width: 360px;
  width: 100%;

  @include min-screen($mq-medium) {
    grid-template-columns: repeat(3, 1fr);
    max-width: 900px;
  }
}

.highlight {
  text-align: center;
  border-radius: 6px;
  padding: 22px 16px;
  color: $color-brand-navy;
}

.highlight1 {
  background-color: $color-brand-yellow-light;
}

.highlight2 {
  background-color: $color-brand-green-light;
}

.highlight3 {
  background-color: $color-brand-blue-grey;
}

.highlightValue {
  font-family: $font-family-heading;
  font-size: 28px;
  font-weight: bold;
  line-height: 1;
  margin-bottom: 8px;
  color: $color-brand-navy;

  @include min-screen($mq-medium) {
    font-size: 36px;
  }
}

.highlightLabel {
  font-size: $font-size-small;
  font-weight: normal;
  color: $color-brand-navy;
}
</style>
